import { CSSProperties } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { PersonPill, Pill } from '@shared/components/pill';
import { PersonField } from '@shared/data/entity/fields/PersonField';
import { User } from '@shared/types/user';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';
import { personCollectionViewFieldStyles } from './PersonCollectionViewFieldStyles';

const MAX_PEOPLE_TO_SHOW = 3;
const MAX_PILL_WIDTH = 180;

interface Props {
  field: PersonField;
  style: StyleProp<ViewStyle>;
  personPillStyle?: StyleProp<ViewStyle>;
  personPillTextStyle?: CSSProperties;
}

export function PersonCollectionViewField({
  field,
  style,
  personPillStyle,
  personPillTextStyle,
}: Readonly<Props>) {
  if (field.isEmpty) {
    return null;
  }

  const peopleToShow: User[] = field.users.slice(0, MAX_PEOPLE_TO_SHOW);
  const remainingPersonCount = field.users.length - MAX_PEOPLE_TO_SHOW;

  return (
    <CardCollectionViewFieldContainer style={[personCollectionViewFieldStyles, style]}>
      {peopleToShow.map(user => (
        <PersonPill
          key={user.id}
          user={user}
          maxWidth={MAX_PILL_WIDTH}
          showLastName={false}
          pillStyle={personPillStyle}
          textStyle={personPillTextStyle}
        />
      ))}
      {remainingPersonCount > 0 && (
        <Pill
          backgroundColor="white"
          sections={[`+${remainingPersonCount}`]}
          round
          noBorder
          textStyle={personPillTextStyle}
        />
      )}
    </CardCollectionViewFieldContainer>
  );
}
